/* eslint-disable */
// https://github.com/couds/react-bulma-switch を使おうと思ったけどメンテ終了してるので参考にしつつ移植
import "bulma-switch/dist/css/bulma-switch.min.css";
import React from "react";

// @ts-ignore
import { Color, Size } from "react-bulma-components/src/modifiers";

export interface SwitchProps {
  children: string;
  id: string;
  name: string;
  value: boolean;
  className?: string;
  size?: Size;
  color?: Color;
  rtl?: boolean;
  rounded?: boolean;
  outlined?: boolean;
  thin?: boolean;
  disabled?: boolean;
  onChange: () => void;
}

export var Switch: React.FC<SwitchProps> = function (props: SwitchProps) {
  return (
    <div className="field">
      <input
        id={props.id}
        type="checkbox"
        name={props.name}
        checked={props.value}
        className={classnames(props)}
        onChange={props.onChange}
        disabled={props.disabled}
      />
      <label htmlFor={props.id}>{props.children}</label>
    </div>
  );
};

// TODO
/*
  classnamesをつかってこんな感じにしたい
          className={classnames('switch', {
            'is-rtl': rtl,
            'is-rounded': rounded,
            'is-outlined': outlined,
            'is-thin': thin,
            [`is-${color}`]: color,
            [`is-${size}`]: size,
          })}
  が、classnamesをtypescriptから使うのがアレだったので一旦避難
  アレ1. @types/classnames has been deprecated.
  アレ2. classnames本体のtypescript対応版が未リリース(次バージョンで入ると思われる)
    https://github.com/JedWatson/classnames/pull/261
    ただし結構放置されてる。
  */
const classnames = (props: SwitchProps) => {
  const classnames: Array<string> = ["switch"];
  if (props.color) {
    classnames.push(`is-${props.color}`);
  }
  if (props.size) {
    classnames.push(`is-${props.size}`);
  }
  if (props.rounded) {
    classnames.push("is-rounded");
  }
  if (props.outlined) {
    classnames.push("is-outlined");
  }
  if (props.thin) {
    classnames.push("is-thin");
  }
  if (props.rtl) {
    classnames.push("is-rtl");
  }
  return classnames.join(" ");
};
/* eslint-enable */
